(ns ycweb.app.website.myaccount.orders.view
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.myaccount.orders.common :as orders-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

;; Components ===================================================================================================================

(rum/defc bundleitem-view-line [app-atom client-order-item]
  (let [{:item-line/keys [variation]
         :client-order-item/keys [comments total-price]} client-order-item]
    [:tr.yc-tr
     {:key (:ent/uuid client-order-item)}
     [:td.yc-td.yc-td--product-image
      (web-common/lazy-image app-atom
        (:doc/public-id (:ent/image variation))
        {:class ["yc-td__image"]}
        {:alt ""})]

     [:td.yc-td.yc-td--voucher-text {:colSpan "3"}
      [:div.yc-td__product-name
       [:span.text-status--sale comments]]]

     [:td.yc-td.yc-td--product-price
      [:span.yc-td__faux-table {:data-th "Total"}
       [:span.yc-td__faux-td (str "R" (u/currency-format total-price))]]]
     [:td.yc-td.yc-td--options.yc-td--hide]]))

(rum/defc orderitem-view-line [app-atom client-order client-order-item]
  (let [{:client-order/keys [for-registry-order-id]} client-order
        {:client-order-item/keys [shipping-info]
         :item-line/keys [variation product]} client-order-item]
    [:tr.yc-tr
     {:key (str "orderitem-view-line" (:ent/uuid client-order-item))}
     [:td
      {:class (u/bem :yc-td [:product-image])}
      (cond
        (:client-order-item/cover-voucher-public-id client-order-item)
        (web-common/lazy-image app-atom
          (:client-order-item/cover-voucher-public-id client-order-item)
          {:class ["yc-td__image"]}
          {:w 100 :h 69})

        (:doc/public-id (:ent/image variation))
        [:a
         ;TODO: Update to uuid when registries are complete
         {:href
          (if for-registry-order-id
            (str "/registry.htm?action=view&orderid=" for-registry-order-id)
            (:link product))}
         (web-common/lazy-image app-atom
           (:doc/public-id (:ent/image variation))
           {:class ["yc-td__image"]}
           {:w 100 :h 100 :c "lpad"})])]
     [:td
      {:class (u/bem :yc-td [:product-text])}
      (when (:client-order-item/registry-item? client-order-item)
        [:div.text-status--info
         [:b "Gift Registry Purchase"]])
      (when (:client-order-item/seconds-item? client-order-item)
        [:div.text-status--info
         [:b "Seconds for Greatness"]])
      (cond
        (:product/link product)
        [:a.block-link
         {:href
          (if for-registry-order-id
            (str "/registry.htm?action=view&orderid=" for-registry-order-id)
            (:product/link product))}
         [:div.yc-td__product-name
          (:ent/display-name product)]

         (let [{:variation/keys [feature1 feature2 display-pack-size pack-description code]} variation
               multi-pack? (and display-pack-size (> display-pack-size 1))
               has-feature? (or (u/presence feature1) (u/presence feature2))]
           (when (or has-feature? multi-pack?)
             [:div.yc-td__product-description
              (when multi-pack? [:b (str pack-description " of " display-pack-size)])
              (when (and multi-pack? has-feature?) [:span.u-pipe " | "])
              (cond
                (and (u/presence feature1) (u/presence feature2)) (str feature1 ", " feature2)
                (u/presence feature1) feature1
                (u/presence feature2) feature2)
              [:span.u-pipe " | "]
              [:span.yc-table__clip-text "Product "]
              (str "Code: " code)]))])

      (when (and (:shipping-info/customer-message shipping-info)
              (not
                (contains? #{"Delivered" "Cancelled" "Collected"}
                  (:client-order/status-text client-order))))
        [:div.yc-td__product-notes
         [:span {:class (str "text-status--" (:shipping-info/customer-class shipping-info))}
          (:shipping-info/customer-message shipping-info)]])

      (when (:client-order-item/comments client-order-item) [:div.yc-td__product-description (:client-order-item/comments client-order-item)])]

     [:td
      {:class (u/bem :yc-td [:centered])}
      [:span.yc-td__faux-table {:data-th "Quantity"}
       [:span.yc-td__faux-td (:item-line/qty client-order-item)]]]

     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Price"}
       [:span.yc-td__faux-td (str "R" (u/currency-format (:client-order-item/price client-order-item)))]]]

     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Total"}
       [:span.yc-td__faux-td (str "R" (u/currency-format (:client-order-item/total-price client-order-item)))]]]

     [:td
      {:class (u/bem :yc-td [:centered])}
      [:span.yc-td__faux-table {:data-th "Options"}
       [:span.yc-td__faux-td
        (cond
          (not (contains? #{"Delivered" "Cancelled" "Collected"} (:client-order/status-text client-order)))
          (when (and (:product/link product) (:product/reviewable product))
            [:a.text-link {:href (:product/link product)} "View Product"])
          :else
          (when (and (:product/reviewable product) (not (:client-order-item/registry-item? client-order-item)))
            [:a.text-link
             (urlstate/href-props app-atom "myaccount" "reviewsadd" {:uuid (:ent/uuid variation)}) "Write a Review"]))]]]]))

(defn order-view-line [app-atom order {:keys [bundle-up] :as client-order-item}]
  (if bundle-up
    (bundleitem-view-line app-atom client-order-item)
    (orderitem-view-line app-atom order client-order-item)))

(defn order-bundle-items-view [app-atom has-bundle-up? client-order [bundle-group-number group-items]]
  (list
    [:tr.yc-tr.yc-tr--section-title
     {:key bundle-group-number}
     (cond
       (and bundle-group-number (pos? bundle-group-number))
       [:td.yc-td {:colSpan "6"} [:b (str "Special bundle " bundle-group-number ":")]]
       has-bundle-up?
       [:td.yc-td {:colSpan "6"} [:b "Other items in this order:"]])]
    (map (partial order-view-line app-atom client-order) group-items)))

(defn order-voucher-line [app-atom redeemed-voucher]
  (let [{:item-line/keys [variation product]} redeemed-voucher]
    [:tr.yc-tr
     {:key (:ent/uuid redeemed-voucher)}
     [:td
      {:class (u/bem :yc-td [:product-image])}
      (when (:ent/image variation)
        (web-common/lazy-image app-atom
          (:doc/public-id (:ent/image variation))
          {:class ["yc-td__image"]}
          {:w 100 :h 100 :q "auto" :c "lpad" :f "auto" :e "sharpen:40"}))]
     [:td
      {:class (u/bem :yc-td [:product-text])}
      (str (:ent/display-name product) " - " (:voucher/code redeemed-voucher))]
     [:td {:class (u/bem :yc-td [:hide])}]
     [:td {:class (u/bem :yc-td [:hide])}]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Total"}
       [:span.yc-td__faux-td
        (str "R" (u/currency-format (:client-order-item/total-price redeemed-voucher)))]]]
     [:td {:class (u/bem :yc-td [:centered :hide])}]]))

;; Order view table
(rum/defc order-view-table [app-atom client-order]
  (let [{:ent/keys [display-name]
         :client-order/keys [items has-bundle-up? redeemed-vouchers total-price is-registry?]} client-order]
    [:table
     {:class (u/bem :yc-table [:order-view])}
     [:caption.yc-table-caption.hidden-from-view (str "Summary of your order " display-name)]
     [:colgroup
      [:col {:width 100}]
      [:col]
      [:col]
      [:col]
      [:col]
      [:col]]
     [:thead.yc-thead
      [:tr.yc-tr
       {:key "header"}
       [:th.yc-th {:scope "col"} "Item"]
       [:th.yc-th {:scope "col"} "Description"]
       [:th
        {:class (u/bem :yc-th [:centered])
         :scope "col"}
        "Q" [:span.yc-table__clip-text "uantity"]]
       [:th.yc-th {:scope "col"} "Price"]
       [:th.yc-th {:scope "col"} "Total"]
       [:th
        {:class (u/bem :yc-th [:centered])
         :scope "col"}
        "Options"]]]

     (into
       [:tbody.yc-tbody]
       (concat
         (cond
           has-bundle-up?
           (map (partial order-bundle-items-view app-atom has-bundle-up? client-order) (group-by :client-order-item/bundle-group-number items))
           :else
           (map (partial order-view-line app-atom client-order) items))
         (when (not-empty redeemed-vouchers)
           [[:tr
             {:key "vouchers"}
             [:td
              {:class (u/bem :yc-td [:1-col])
               :colSpan "6"}
              [:b "Vouchers, discounts and deductions"]]]
            (map (partial order-voucher-line app-atom) redeemed-vouchers)])
         (when (or (not-empty items) (not-empty redeemed-vouchers))
           [[:tr
             {:class (u/bem :yc-tr-footer [:order-total]) :key "footer"}
             [:td.yc-td {:colSpan "5"}
              [:span.yc-td__order-total-text
               "Order Total "
               (when (not is-registry?)
                 [:span.yc-td__order-total-note
                  "(Including VAT, delivery & everything else)"])]]
             [:td
              {:class (u/bem :yc-td [:centered])
               :colSpan "2"}
              [:span.yc-td__order-total-price (str "R" (u/currency-format total-price))]]]])))]))

(rum/defc order-view < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)

        {:client-order/keys [status-text deliveries billing-details delivery-details] :as client-order} (cmn/curact action-atom [:client-order])
        store-detail (cmn/curact action-atom [:store-detail])
        collection-point-detail (cmn/curact action-atom [:collection-point-detail])
        show-reorder? (cmn/curact action-atom [:show-reorder?])
        return-case (cmn/curact action-atom [:return-case])]
    [:div.dashboard
     (if (:ent/display-name return-case)
       (headings/heading (str "Resolution Order " (:ent/display-name client-order)) {:type :h2 :size :medium})
       (headings/heading (str "Order " (:ent/display-name client-order)) {:type :h2 :size :medium}))

     (when (:ent/display-name return-case)
       (feedback/feedback
         :info ""
         [:span "This is the resolution order for your return case " (:ent/display-name return-case) ". "
          ;;todo - redirect needed?
          ;;todo - switch to using uuid
          [:a (urlstate/href-props app-atom "myaccount" "viewreturn" {:uuid (:ent/uuid return-case)}) "View return case."]]))

     [:div.u-margin-bottom-40
      (feedback/feedback
        (if (contains? #{"Delivered" "Collected"} status-text) :success :info)
        ;TODO rather send through a boolean value for this check instead of the id
        (if (and (contains? #{"Delivered" "Collected"} status-text) (:client-order/for-registry-order-id client-order))
          [:a {:href "/help.htm?action=article&id=43"} "For Registry"]
          status-text)
        (cond
          (and (not-empty deliveries) (not (:ent/display-name return-case)))
          (map
            (fn [{ent-uuid :ent/uuid
                  :delivery/keys [date-delivered company-name tracking-url waybill-number emailed-order-shipped] :as delivery}]
              [:span
               {:key ent-uuid}
               (if date-delivered
                 [:span (str (if (= status-text "Collected") "Collected" "Arrived") " - ")
                  [:span.clip-text.unclip-text--t.clip-text--ma.unclip-text--l (ud/date-format (ud/coerce-date date-delivered) "dd MMM YYYY")]]
                 [:span
                  (cond
                    (= company-name "Ready for Collection")
                    (if (and (= emailed-order-shipped 0) (not (contains? #{"Delivered" "Collected"} status-text)))
                      [:a {:href "/help.htm?action=article&id=29&name=Order-Collections"} "Await Notification"]
                      "To Collect")
                    :else company-name)
                  (when (= company-name "Store Sale") [:span " - " (ud/date-format (ud/coerce-date (:client-order/date-placed client-order)) "dd MMM YYYY")])])

               (when (and (u/presence tracking-url) (u/presence waybill-number))
                 [:span " - " [:a.text-link {:href (str (u/presence tracking-url) (u/presence waybill-number)) :target "_blank"} "Track"]]) [:br]])
            deliveries)
          :else
          ""))]
     [:div {:class (u/bem :flex-grid-group [:flush])}
      [:div {:class (u/bem :flex-grid-block [:s-1-2])}
       [:div.flex-grid-content.order-detail-address
        (cond
          ;TODO rather send through boolean for this check
          (:client-order/for-registry-order-id client-order)
          [:span
           (headings/heading "Registry Purchase" {:type :h3 :size :tiny})
           [:p
            {:class (u/bem :yc-paragraph [:small :flush])}
            [:b "Please note: "]
            "Your order will be delivered directly to the happy couple, together with their other gifts,
            once they have closed their registry and asked us to deliver it."]
           [:p
            {:class (u/bem :yc-paragraph [:small :flush])}
            [:a
             {:href "/help.htm?action=article&id=43&name=Buying-a-Registry-Gift"
              :class (u/bem :text-link [:muted])}
             "Learn more."]]]

          :else
          (cond
            (and
              (= (:delivery/company-name (first deliveries)) "By Hand")
              (= (:client-order/order-type client-order) "Shop")
              (= (count deliveries) 1)
              store-detail)
            [:span
             (headings/heading "Shop Address" {:type :h3 :size :tiny})
             (into
               [:p
                {:class (u/bem :yc-paragraph [:small :flush])}]
               (let [{:ent/keys [display-name]
                      :address/keys [address suburb city postal-code]} store-detail]
                 (orders-common/address-block [(str "Yuppiechef " display-name) address suburb city postal-code])))]

            (and (= (:delivery/delivery-category delivery-details) "Collection") collection-point-detail)
            [:span
             (headings/heading "Store Collection" {:type :h3 :size :tiny})
             (into
               [:p
                {:class (u/bem :yc-paragraph [:small :flush])}]
               (let [{:ent/keys [display-name]
                      :address/keys [address suburb city postal-code]} collection-point-detail]
                 (orders-common/address-block [(:contact/name (:delivery/contact delivery-details)) (str "Yuppiechef " display-name) address suburb city postal-code])))]

            :else
            [:span
             (headings/heading "Delivery Address" {:type :h3 :size :tiny})
             (into
               [:p
                {:class (u/bem :yc-paragraph [:small :flush])}]
               (let [{:delivery/keys [contact address city suburb postal-code]} delivery-details]
                 (orders-common/address-block [(:contact/name contact) address city suburb postal-code])))]))]]

      [:div {:class (u/bem :flex-grid-block [:s-1-2])}
       [:div.flex-grid-content.order-detail-address
        (headings/heading "Billing address" {:type :h3 :size :tiny})
        [:p
         {:class (u/bem :yc-paragraph [:small :flush])}

         (when (:contact/name (:billing/contact billing-details))
           [:span (:contact/name (:billing/contact billing-details)) [:br]])

         (cond
           (:billing/address billing-details)
           (let [{:billing/keys [address city suburb postal-code]} billing-details]
             (into [:span]
               (orders-common/address-block [address city suburb postal-code])))
           :else
           (let [{:delivery/keys [address city suburb postal-code]} delivery-details]
             (into [:span] (orders-common/address-block [address city suburb postal-code]))))]]]]

     (order-view-table app-atom client-order)

     [:div.dashboard-footer.button-group
      (when (:client-order/is-registry? client-order)
        (buttons/button-web "Show Purchased Gifts"
          {:href (str "/registry.htm?action=guestpurchaselist&orderid=" (:client-order/id client-order))
           :target "_blank"
           :style :dark
           :size :small}))

      (when (:client-order/is-invoiced? client-order)
        (buttons/button-web "Print invoice"
          {:href (str "/invoice.htm?display=desktop&overrideincludes=a4&action=view&uuid=" (:ent/uuid client-order))
           :style :dark
           :size :small}))

      ;Only applicable to Cancelled status as abandoned carts are not shown here anymore
      (when (contains? #{"Cancelled" "Current Cart" "Inactive Cart"} status-text)
        (buttons/button-web "Archive this order"
          {:on-click #(grid/dispatch-action app-atom :web.myaccount.order/archive {:orderuuid (:ent/uuid client-order)})
           :target "_blank"
           :style :light
           :size :small}))

      ;TODO: Inactive carts are not shown in this view so these conditions can't be true - not supporting for now.
      #_(cond
          (= statustext "Inactive Cart")
        ;;todo - set cart
          (buttons/button-web "Make this my Cart"
            {:href (str "/myaccount.htm?action=setcart&orderid=" orderid)
             :target "_blank"
             :style :light
             :size :small})

        ;;todo - reorder items
          (and (= statustext "Current Cart") (not forregistryorderid) showreorder?)
          (buttons/button-web "Re-order these items"
            {:href (str "/myaccount.htm?action=reorder&orderid=" orderid)
             :target "_blank"
             :style :light
             :size :small}))]
     (toaster/loading-overlay app-atom :web.myaccount/orderview)]))

;; Routing ===================================================================================================================

(defmethod flow/render-screen :web.myaccount/trackview [app-atom _]
  (awm.common/screen-wrapper app-atom
    (order-view app-atom)))

(defmethod t/transition-open :web.myaccount/trackview [app-atom _ params]
  (let [action-atom (cmn/action-cursor app-atom)]
    (toaster/open-overlay app-atom :web.myaccount/orderview)
    (swap! action-atom dissoc :order)
    (comms/ajax-get :web.myaccount/trackview (select-keys params [:uuid]))))

(defmethod comms/receive :web.myaccount/trackview [app-atom e]
  (swap!
    (cmn/action-cursor app-atom) assoc
    :client-order (:client-order e)
    :store-detail (:store-detail e)
    :collection-point-detail (:collection-point-detail e)
    :return-case (:return-case e)
    :show-reorder? (:show-reorder? e))
  (toaster/close-overlay app-atom :web.myaccount/orderview))

(defmethod grid/action :web.myaccount.order/archive [app-atom config _]
  (toaster/open-toast app-atom :processing "Archiving" {:closetime 10000})
  (comms/ajax-get :web.myaccount/archiveorder config))

(defmethod comms/receive :web.myaccount/archiveorder [app-atom e]
  (if (:success e)
    (do
      (toaster/open-toast app-atom :success "Archived" {:closetime 2000})
      (urlstate/redirect app-atom "myaccount" "orders"))
    (toaster/open-toast app-atom :error "Could not archive order." {:closetime 5000})))
